"use client"

import { Logo } from "@/components/logo/logo"
import { MenuIcon } from "@/components/menu-icon/menu-icon"

import { useState } from "react"
import Link from "next/link"

import styles from "./header.module.css"

const menuLinks = [
  { label: "Home", url: "/" },
  { label: "Blog", url: "/blog" },
  { label: "Press", url: "/press" },
  { label: "Privacy", url: "/privacy" }
]

const getYear = () => {
  return new Date().getFullYear()
}

export function Header() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <header className={`${styles["header"]}`}>
        <Link href="/">
          <Logo height="17" width="110" />
        </Link>
        <div className={styles["navRight"]}>
          <MenuIcon
            icon="hamburger"
            onClick={() => {
              setIsOpen(!isOpen)
            }}
          />
        </div>
      </header>
      <menu className={styles["menuContainer"]} is-open={isOpen ? "" : null}>
        <div className={styles["header"]} close-container="true">
          <MenuIcon
            icon="close"
            onClick={() => {
              setIsOpen(false)
            }}
          />
        </div>
        <ul>
          {menuLinks.map(link => (
            <li key={link.url} className={styles["menuItem"]}>
              <Link
                href={link.url}
                onClick={() => {
                  setIsOpen(false)
                }}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
        <div className={styles["copyrightContainer"]}>
          <span>© {getYear()} Agency AI, Inc.</span>
        </div>
      </menu>
    </>
  )
}
